const resignationDataSource = {
  data: [],
  callback: null,

  init(callback) {
    this.callback = callback
    if (this.data.length > 0) {
      this.notifyChange()
    }
  },

  setData(newData) {
    this.data = newData.map(item => ({
      ...item,
      status: item.status || 'pending',
      createTime: item.createTime || this.getCurrentTime()
    }))
    this.notifyChange()
  },

  addItem(item) {
    const newItem = {
      ...item,
      id: item.id || Date.now(),
      status: item.status || 'pending',
      createTime: this.getCurrentTime(),
      timeline: []
    }
    this.data.unshift(newItem)
    this.notifyChange()
    return newItem
  },

  updateItem(id, updates) {
    const index = this.data.findIndex(item => item.id === id)
    if (index !== -1) {
      this.data[index] = {
        ...this.data[index],
        ...updates,
        updateTime: this.getCurrentTime()
      }
      this.notifyChange()
      return this.data[index]
    }
    return null
  },

  updateStatus(id, newStatus, timelineItem) {
    const item = this.data.find(item => item.id === id)
    if (item) {
      item.status = newStatus
      if (timelineItem) {
        item.timeline = item.timeline || []
        item.timeline.unshift({
          ...timelineItem,
          time: this.getCurrentTime()
        })
      }
      this.notifyChange()
      return item
    }
    return null
  },

  deleteItem(id) {
    const index = this.data.findIndex(item => item.id === id)
    if (index !== -1) {
      this.data.splice(index, 1)
      this.notifyChange()
      return true
    }
    return false
  },

  getItem(id) {
    return this.data.find(item => item.id === id)
  },

  getAll() {
    return [...this.data].sort((a, b) => {
      const timeA = a.createTime || '1970-01-01 00:00:00'
      const timeB = b.createTime || '1970-01-01 00:00:00'
      return timeB.localeCompare(timeA)
    })
  },

  notifyChange() {
    if (this.callback && typeof this.callback === 'function') {
      this.callback(this.getAll())
    }
  },

  getCurrentTime() {
    const now = new Date()
    const year = now.getFullYear()
    const month = String(now.getMonth() + 1).padStart(2, '0')
    const day = String(now.getDate()).padStart(2, '0')
    const hours = String(now.getHours()).padStart(2, '0')
    const minutes = String(now.getMinutes()).padStart(2, '0')
    const seconds = String(now.getSeconds()).padStart(2, '0')
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
  },

  pushToThirdParty() {
    return {
      success: true,
      data: this.data,
      timestamp: this.getCurrentTime()
    }
  }
}

export default resignationDataSource
